<template>
  <div class="t-image-info flex gap-x-4">
    <div class="relative flex-none w-20 lg:w-36">
      <TLazyimg
        :src="image"
        alt=""
        classes="block w-full h-none aspect-w-4 aspect-h-3 lg:aspect-w-16 lg:aspect-h-12"
        classes-img="block w-full h-full rounded-lg lg:rounded-xl"
      />
    </div>

    <div class="">
      <TText variant="semibold" size="lg" classes="mb-0">
        {{ title }}
      </TText>
      <TText color="text-gray-900" classes="mb-0">
        {{ subtitle }}
      </TText>
      <div class="flex">
        <TStars :stars="stars" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface TAvatar_Props {
  title: string
  image: string
  subtitle: string
  stars: number
}

defineProps<TAvatar_Props>()
</script>
